export const SimpleStepItemsTableColumns = (isArabic) => [
    { id: 'title', label: isArabic ? 'العنوان' : 'Title', align: 'start' },
    { id: 'is_active', label: isArabic ? 'الحالة' : 'Status', align: 'center' },
    { id: 'sort_order', label: isArabic ? 'الترتيب' : 'Sort Order', align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' },
];
